import { fbt } from 'fbtee'
import { cn } from '../lib/utils'

/** Marks a schedule set card whose time or stage changed since the user last looked: a dot + "Updated", or the dot alone. */
export function UpdatedChip({
  variant = 'pill',
  ghost = false,
  className,
}: {
  variant?: 'pill' | 'dot'
  /** A hidden pill kept only to measure whether it fits — not a chip the user sees. */
  ghost?: boolean
  className?: string
}) {
  if (variant === 'dot') {
    return (
      <span
        data-testid="set-updated-chip"
        role="img"
        aria-label={fbt('Time or stage updated', 'Accessible label for the dot marking a compact schedule set card whose time or stage changed')}
        // inline-block: a bare inline span ignores its size inside a block parent.
        className={cn('inline-block size-2 rounded-full bg-warning shrink-0', className)}
      />
    )
  }
  return (
    // Unfilled on purpose: a status line beside the time, not a badge that
    // outweighs the artist's name. The dot is the same mark short cards show alone.
    <span
      data-testid={ghost ? undefined : 'set-updated-chip'}
      aria-hidden={ghost || undefined}
      className={cn(
        'inline-flex items-center gap-1 text-[10px] @[128px]:text-xs font-medium leading-none text-warning shrink-0',
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-warning shrink-0" />
      {fbt('Updated', 'Chip on a schedule set card whose time or stage changed since the user last opened the schedule')}
    </span>
  )
}
